import React from "react";
import { PageHeader } from "../components/PageHeader";
import { Hammer } from "lucide-react";

export default function Placeholder({ title }) {
  return (
    <div className="animate-fade-in-up">
      <PageHeader title={title || "قريبًا"} />
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <Hammer size={56} className="text-[#9CA3AF] mb-3" />
        <p className="text-base font-bold text-[#161629]">هذه الصفحة قيد الإنشاء</p>
        <p className="text-sm text-[#6B7280] mt-1">سيتم تفعيلها قريبًا على الويب</p>
      </div>
    </div>
  );
}
